import { render, staticRenderFns } from "./social-post-template-publish-widget.vue?vue&type=template&id=7fe36c38&"
import script from "./social-post-template-publish-widget.vue?vue&type=script&lang=js&"
export * from "./social-post-template-publish-widget.vue?vue&type=script&lang=js&"
import style0 from "./social-post-template-publish-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports